import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import LoginLayoutComponent, {
    CREATE_LAYOUT,
    FACEBOOK_REAUTHORIZATION_CONFIRMATION_LAYOUT,
    FACEBOOK_REAUTHORIZATION_LAYOUT,
    LOGIN_LAYOUT,
    POPUP_MODE,
    RESET_PASSWORD_CONFIRMATION_LAYOUT,
    RESET_PASSWORD_LAYOUT,
} from '../LoginLayoutComponent/LoginLayoutComponent';
import LoginImageContainer from './LoginImageContainer/LoginImageContainer';
import './LoginWall.scss';

const colorToRGBA = {
    white: 'rgb(255,255,255, 0.7)',
    black: 'rgba(0, 0, 0, 0.7)',
};

export default class LoginWall extends React.PureComponent {
    constructor(props) {
        super();

        this.state = {
            placementName: null,
            allowClosing: null,
            buttonText: '',
            delaySeconds: null,
            description: '',
            image: null,
            overlayColor: null,
            redirectUrl: null,
            title: '',
            isOpened: false,
            showLoginWidget: false,
        };
    }

    static propTypes = {
        /**
         * Whether or not the component will be displayed in
         */
        layoutType: PropTypes.oneOf([
            CREATE_LAYOUT,
            LOGIN_LAYOUT,
            RESET_PASSWORD_LAYOUT,
            RESET_PASSWORD_CONFIRMATION_LAYOUT,
            FACEBOOK_REAUTHORIZATION_LAYOUT,
            FACEBOOK_REAUTHORIZATION_CONFIRMATION_LAYOUT,
        ]).isRequired,
        /**
         * auth0 config
         */
        auth0: PropTypes.shape({
            domain: PropTypes.string,
            clientId: PropTypes.string,
            db: PropTypes.string,
        }).isRequired,
        /**
         * sign up success redirect uri
         */
        loginRedirectPath: PropTypes.string.isRequired,
        /**
         * url path header
         */
        redirectUri: PropTypes.string.isRequired,
        /**
         * the url object that has currnet page, path, host, & protocol information
         */
        url: PropTypes.object,
        /**
         *  function to increase the number in local storage
         */
        setLastSignupWallPageView: PropTypes.func,
        /**
         *  login wall data from backend
         */
        loginWallData: PropTypes.object,
        /**
         *  function to close this loginwall
         */
        closeLoginWall: PropTypes.func,
    };

    static defaultProps = {
        layoutType: LOGIN_LAYOUT,
        setLastSignupWallPageView: () => {},
        closeLoginWall: () => {},
    };

    openLoginWidget = () => {
        this.setState({ showLoginWidget: true });
        EmitMetric({
            misc_event_type: 'signup-wall-button',
            misc_event_count: 1,
            test_flag: this.props.placementName,
        });
    };

    renderLoginWall = () => {
        const {
            placementName,
            image,
            overlayColor,
            title,
            description,
            buttonText,
            allowClosing,
        } = this.props.loginWallData;
        const {
            redirectUri,
            loginRedirectPath,
            auth0,
            layoutType,
        } = this.props;

        const displayAtBoth = 'd-block d-md-block';
        const hideAtMobile = 'd-none d-md-block';
        const imageContainerCss = this.state.showLoginWidget
            ? hideAtMobile
            : displayAtBoth;
        const loginWidgetCss = this.state.showLoginWidget
            ? displayAtBoth
            : hideAtMobile;

        return (
            <div
                className="component-Login-LoginWall overlay"
                style={{ backgroundColor: `${colorToRGBA[overlayColor]}` }}
            >
                <div className={`popup`}>
                    <section className={`left ${imageContainerCss}`}>
                        <LoginImageContainer
                            openLoginWidget={this.openLoginWidget}
                            closeLoginWall={this.props.closeLoginWall}
                            title={title}
                            description={description}
                            buttonText={buttonText}
                            image={image}
                            allowClosing={allowClosing === 1 ? true : false}
                            placementName={placementName}
                            cmsPreview={false}
                        />
                    </section>

                    <section className={`right ${loginWidgetCss}`}>
                        <LoginLayoutComponent
                            auth0={auth0}
                            hidePopup={this.props.closeLoginWall}
                            displayMode={POPUP_MODE}
                            layoutType={layoutType}
                            loginRedirectPath={loginRedirectPath}
                            redirectUri={redirectUri}
                            allowClosing={allowClosing === 1 ? true : false}
                            loginMetrics={{
                                login_trigger: 'signup-wall',
                                test_flag: placementName,
                            }}
                        />
                    </section>
                </div>
            </div>
        );
    };

    render() {
        return this.props.isOpened ? this.renderLoginWall() : null;
    }
}
